module.exports = __webpack_public_path__ + "static/img/14000137.da1f694b.png";